import * as React from "react";
import {
  ActivityFragment,
  CompanyMinimalFragment,
} from "../../../graphql/fragments";
import useTranslations from "../../../hooks/useTranslations";
import { BuildingIcon } from "../../icons";
import { Span } from "../../wombat-ui/components/Typography";
import Activity from "../ActivityPlate";

interface CompanyUpdatedActivityProps {
  activity: CompanyUpdatedActivity;
}

type CompanyUpdatedActivity = ActivityFragment & {
  recipient: CompanyMinimalFragment;
  trackable: CompanyMinimalFragment;
};

export function isCompanyUpdatedActivity(
  q: ActivityFragment
): q is CompanyUpdatedActivity {
  return q.key === "company.updated";
}

interface CompanyUpdatedActivityProps {
  activity: CompanyUpdatedActivity;
}

export const CompanyUpdatedActivity: React.FC<CompanyUpdatedActivityProps> = ({
  activity,
}) => {
  const t = useTranslations();

  return (
    <Activity
      activity={activity}
      id="companyUpdatedActivity"
      visual={<BuildingIcon iconClassName="w-10 h-10 text-accent-500" />}
    >
      <Span className="text-sm">
        {t("activity.labels.companyUpdated", {
          company: activity.trackable.name,
        })}
      </Span>
    </Activity>
  );
};
